import {MainTokenStorageHandler} from '@guestapp/sdk';

const PAYLOAD = 1;

export const getUserId = (): string => {
  try {
    const storageToken = MainTokenStorageHandler.getToken();
    if (storageToken !== null) {
      const payload = storageToken.split('.')[PAYLOAD];
      const {user_id} = JSON.parse(atob(payload)) as {user_id: string};

      return user_id;
    }
  } catch (err) {
    console.error(err);
  }

  throw new Error('Failed to get user id');
};
